var exports = {
  "N4": "x31de4314--cefbc5--note",
  "OR": "x31de4314--cefbc5--danger",
  "Kk": "x31de4314--cefbc5--icon",
  "jD": "x31de4314--cefbc5--cont",
};

module.exports = exports;
